import React, { useState } from 'react'
import QuestionMark from '../../../assets/svg/question-mark.svg'
import { Badge, makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { AddressModal } from './address-modal'
import EditIcon from '@material-ui/icons/CreateOutlined'
import { isEmpty } from 'lodash'

export function LocationWithoutAddressTooltip({
    locationsWithoutCoordinates,
    locationsWithAddressAndWithoutCoordinates
}) {
    const classes = useStyles()
    const [isOpenLocationsTooltip, setIsOpenLocationsTooltip] = useState(false)
    const { locale } = useSelector(state => state.main)

    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false)
    const [selectedLocation, setSelectedLocation] = useState(null)

    const handleClick = () => {
        setIsOpenLocationsTooltip(!isOpenLocationsTooltip)
    }
    const handleLocationClick = location => {
        setSelectedLocation(location)
        setIsAddressModalOpen(true)
    }

    const LocationItem = ({ location }) => {
        return (
            <div
                className={classes.location}
                onClick={() => handleLocationClick(location)}
            >
                {location.name}
                <EditIcon style={{ width: 16, height: 16, marginLeft: 4 }} />
            </div>
        )
    }

    const Locations = () => {
        return (
            <div className={classes.locationsWrapper}>
                {!isEmpty(locationsWithoutCoordinates) ? (
                    <div>
                        <span>
                            {`(${locationsWithoutCoordinates.length})`}{' '}
                            {locale.locations.locationsWithoutAddressLabel}
                        </span>
                        {locationsWithoutCoordinates
                            .slice(0, 7)
                            .map(location => {
                                return (
                                    <LocationItem
                                        key={location.id}
                                        location={location}
                                    />
                                )
                            })}
                        {locationsWithoutCoordinates.length > 7 && (
                            <span style={{ fontSize: '14px', fontWeight: 700 }}>
                                ...
                            </span>
                        )}
                    </div>
                ) : null}
                {!isEmpty(locationsWithAddressAndWithoutCoordinates) ? (
                    <div style={{ marginTop: 24 }}>
                        <span>
                            {`(${locationsWithAddressAndWithoutCoordinates.length})`}{' '}
                            {
                                locale.locations
                                    .locationsWithoutAddressAndWithoutCoordsLabel
                            }
                        </span>
                        {locationsWithAddressAndWithoutCoordinates
                            .slice(0, 7)
                            .map(location => {
                                return (
                                    <LocationItem
                                        key={location.id}
                                        location={location}
                                    />
                                )
                            })}
                        {locationsWithAddressAndWithoutCoordinates.length >
                            7 && (
                            <span style={{ fontSize: '14px', fontWeight: 700 }}>
                                ...
                            </span>
                        )}
                    </div>
                ) : null}
            </div>
        )
    }

    if (
        isEmpty(locationsWithoutCoordinates) &&
        isEmpty(locationsWithAddressAndWithoutCoordinates)
    ) {
        return null
    }

    return (
        <>
            <div className={classes.tooltip} onClick={handleClick}>
                <div className={classes.iconWrapper} onClick={handleClick}>
                    <img className={classes.icon} src={QuestionMark} />
                    <Badge
                        className={classes.showCountInfo}
                        badgeContent={
                            locationsWithoutCoordinates.length +
                            locationsWithAddressAndWithoutCoordinates.length
                        }
                        color="error"
                    />
                </div>
                {isOpenLocationsTooltip && <Locations />}
                <AddressModal
                    open={isAddressModalOpen}
                    onClose={() => setIsAddressModalOpen(false)}
                    location={selectedLocation}
                />
            </div>
        </>
    )
}

const useStyles = makeStyles(theme => ({
    tooltip: {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: '20px',
        zIndex: 1000,
        background: 'white',
        height: '40px',
        width: '40px',
        borderRadius: '50%',
        '&:hover': {
            cursor: 'pointer'
        },
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
    },
    iconWrapper: {
        position: 'relative',
        height: '40px',
        width: '40px'
    },
    icon: {
        position: 'absolute',
        top: '22.5%',
        left: '22.5%'
    },
    showCountInfo: {
        position: 'absolute',
        top: 0,
        right: 0
    },
    locationsWrapper: {
        position: 'absolute',
        top: 50,
        right: 0,
        minWidth: 400,
        backgroundColor: 'white',
        opacity: 0.9,
        padding: '12px',
        borderRadius: '12px',
        cursor: 'default'
    },
    location: {
        marginTop: 8,
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        '&:hover': {
            color: theme.primaryHover
        }
    }
}))
